import { jsx as _jsx } from "react/jsx-runtime";
import { FAQList } from './templates/FAQList/FAQList';
import * as Styled from './HelpCenter.style';
// --- MOCKS ESPECÍFICOS DO FAQ LIST ---
const mockFaqCards = [
    {
        type: 'CANCELAMENTO',
        linkText: 'Como posso desistir do curso em que estou matriculado(a)?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ACESSO',
        linkText: 'Como posso rever o conteúdo de um curso já concluído?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ACESSO',
        linkText: 'Como acessar o curso em que estou matriculado(a)?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ACESSO',
        linkText: 'Não atingi 100% de conclusão, mesmo tendo finalizado o curso. O que fazer?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ATUALIZAR',
        linkText: 'Como verificar se meu navegador Mozilla Firefox está atualizado?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ATUALIZAR',
        linkText: 'Como verificar se o meu navegador Google Chrome está atualizado?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ACESSO',
        linkText: 'Quais os requisitos recomendados para o bom desenvolvimento do curso?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'CERTIFICADO',
        linkText: 'Como posso ter acesso aos meus certificados?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
    {
        type: 'ACESSO',
        linkText: 'Os cursos e trilhas ofertados são gratuitos?',
        href: '#',
        isInEditor: false,
        cqPath: 'path/to/component'
    },
];
const mockFilterSections = [
    {
        label: 'Categorias',
        options: [
            { id: '1', label: 'Acesso', value: 'ACESSO', checked: true },
            { id: '2', label: 'Cancelamento', value: 'CANCELAMENTO', checked: false },
            { id: '3', label: 'Atualizar', value: 'ATUALIZAR', checked: false },
            { id: '4', label: 'Certificado', value: 'CERTIFICADO', checked: false },
        ],
    },
];
// --- COMPONENTE DE PÁGINA ---
export const HelpCenterPage = () => {
    return (_jsx(Styled.Fragment, { children: _jsx(FAQList, { faqCards: mockFaqCards, filterSections: mockFilterSections, inverse: false }) }));
};
//# sourceMappingURL=HelpCenter.js.map